import React from 'react'

import { Button, Grid, Row, Col } from 'react-bootstrap'

import { FieldGroup } from './FieldGroup'

import cn from 'classnames'

export const CompleteProfileForm = ({ onSubmit, onChange, validateForm, firstName, lastName, title, phone, phoneExt, children }) => (
  <div className="complete-profile mb-x2">
    <h1>Complete Your Profile</h1>

    {children}

    <form onSubmit={onSubmit} className="col">
      <Row>
        <Col xs={10} xsOffset={1}>
          <FieldGroup id="firstName" label="First Name" value={firstName} onChange={onChange} autoFocus />
        </Col>
      </Row>
      <Row>
        <Col xs={10} xsOffset={1}>
          <FieldGroup id="lastName" label="Last Name" value={lastName} onChange={onChange} />
        </Col>
      </Row>
      <Row>
        <Col xs={10} xsOffset={1}>
          <FieldGroup id="title" label="Job Title" value={title} onChange={onChange} data-optional placeholder="optional" />
        </Col>
      </Row>
      <Row>
        <Col xs={6} xsOffset={1}>
          <FieldGroup id="phone" label="Phone Number" value={phone} onChange={onChange} />
        </Col>
        <Col xs={4}>
          <FieldGroup id="phoneExt" label="Phone Extension" value={phoneExt} onChange={onChange} data-optional placeholder="optional" />
        </Col>
      </Row>
      <Row>
        <Col xs={6} xsOffset={4}>
          <Button id="complete-profile-button" className="btn btn-default" type="submit" disabled={!validateForm()}>
            Complete Profile
          </Button>
        </Col>
      </Row>
    </form>


  </div >
)
